import gql from 'graphql-tag';

const CREATE_KB_COLLECTION = gql`
  mutation($input: CreateCollectionInput!) {
    createKbCollection(input: $input) {
      itemId
      name
      parent {
        itemId
        name
      }
    }
  }
`;

const UPDATE_KB_COLLECTION = gql`
  mutation($input: UpdateCollectionInput!) {
    updateKbCollection(input: $input) {
      itemId
      name
      parent {
        itemId
        name
      }
    }
  }
`;

const CREATE_ARTICLE = gql`
  mutation($input: CreateArticleInput!) {
    createKbArticle(input: $input) {
      itemId
      name
      parent {
        itemId
        name
        parent {
          itemId
          name
        }
      }
      description
      status
      createdBy {
        userId
        name
      }
      createdOn
      lastModifiedBy {
        userId
        name
      }
      lastModifiedOn
      contentUrl
      viewCount
      articleType
      visibility {
        mappingId
        clientSharedType
        siteSharedType
        userRoleSharedType
        userSharedType
        groupSharedType
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        roles {
          roleId
          name
        }
        users {
          userId
          name
        }
        groups {
          groupId
          name
        }
        portalType
      }
    }
  }
`;

const UPDATE_ARTICLE = gql`
  mutation($input: UpdateArticleInput!) {
    updateKbArticle(input: $input) {
      itemId
      name
      parent {
        itemId
        name
        parent {
          itemId
          name
        }
      }
      description
      status
      createdBy {
        userId
        name
      }
      createdOn
      lastModifiedBy {
        userId
        name
      }
      lastModifiedOn
      loginRequired
      contentUrl
      viewCount
      articleType
      visibility {
        mappingId
        clientSharedType
        siteSharedType
        userRoleSharedType
        userSharedType
        groupSharedType
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        roles {
          roleId
          name
        }
        users {
          userId
          name
        }
        groups {
          groupId
          name
        }
        portalType
      }
    }
  }
`;

const DELETE_ARTICLE = gql`
  mutation($input: DeleteArticleInput!) {
    deleteKbArticle(input: $input)
  }
`;

const BULK_MOVE_ARTICLE = gql`
  mutation($input: BulkArticleMoveInput!) {
    moveArticles(input: $input) {
      itemId
    }
  }
`;

const BULK_PUBLISH_ARTICLE = gql`
  mutation($input: BulkArticlePublishInput!) {
    publishArticles(input: $input)
  }
`;

const UDPATE_ARTICLE_VIEW_COUNT = gql`
  mutation($input: ArticleViewCountInput!) {
    incrementArticleViews(input: $input)
  }
`;

const CREATE_ARTICLE_FEEDBACK = gql`
  mutation($input: CreateKbArticleFeedbackInput!) {
    createKbArticleFeedback(input: $input) {
      feedbackId
      kbArticle {
        itemId
        name
      }
      feedback
      status
      feedbackBy {
        userId
        name
      }
      createdOn
      resolvedBy {
        userId
        name
      }
      resolvedOn
    }
  }
`;

const RESOLVE_ARTICLE_FEEDBACK = gql`
  mutation($input: BulkResolveKbArticleFeedbacksInput!) {
    resolveKbArticleFeedbacks(input: $input)
  }
`;

const BULK_UPDATE_ARTICLE_VISIBILITY = gql`
  mutation($input: BulkArticlePublishInput!) {
    publishArticles(input: $input)
  }
`;

const BULK_UPDATE_ARTICLE_MOVE = gql`
  mutation($input: BulkArticleMoveInput!) {
    moveArticles(input: $input) {
      itemId
    }
  }
`;

const DELETE_COLLECTION = gql`
  mutation($input: DeleteKbCollectionInput!) {
    deleteKbCollection(input: $input)
  }
`;

const GENERATE_SHARE_LINK = gql`
  mutation($input: GenerateKbArticleShareLinkInput!) {
    generateKbArticleShareLink(input: $input) {
      url
    }
  }
`;

export {
  CREATE_KB_COLLECTION,
  UPDATE_KB_COLLECTION,
  CREATE_ARTICLE,
  UPDATE_ARTICLE,
  DELETE_ARTICLE,
  DELETE_COLLECTION,
  BULK_MOVE_ARTICLE,
  BULK_PUBLISH_ARTICLE,
  UDPATE_ARTICLE_VIEW_COUNT,
  CREATE_ARTICLE_FEEDBACK,
  RESOLVE_ARTICLE_FEEDBACK,
  BULK_UPDATE_ARTICLE_VISIBILITY,
  BULK_UPDATE_ARTICLE_MOVE,
  GENERATE_SHARE_LINK
};
